<template>
  <CentralSeeds @show-notification="repasseNotificacao" />
</template>

<script setup>
import CentralSeeds from '@/components/configuracoes/seeds/CentralSeeds.vue'

const emit = defineEmits(['show-notification'])

function repasseNotificacao (payload) {
  emit('show-notification', payload)
}
</script>
